import { isDriveVideoFile } from "./driveFolder";

export type VideoAttachmentLike = {
  type?: string;
  name?: string;
  url?: string;
};

/** Transcoded output from MediaConvert — matches backend `isPlaybackVideoUrl`. */
export function isPlaybackVideoUrl(url: string): boolean {
  const lower = url.toLowerCase().split(/[?#]/)[0] || "";
  return lower.endsWith("-playback.mp4");
}

/** Video uploaded but not yet swapped to the `*-playback.mp4` URL. */
export function isVideoAttachmentProcessing(
  attachment: VideoAttachmentLike
): boolean {
  const url = attachment.url?.trim();
  if (!url) return false;
  if (!isDriveVideoFile(attachment.type, attachment.name ?? url)) {
    return false;
  }
  return !isPlaybackVideoUrl(url);
}

export function getVideoProcessingAttachments(
  attachments?: VideoAttachmentLike[] | null
): VideoAttachmentLike[] {
  return (attachments ?? []).filter(isVideoAttachmentProcessing);
}

export function noticeHasVideoProcessing(
  attachments?: VideoAttachmentLike[] | null
): boolean {
  return getVideoProcessingAttachments(attachments).length > 0;
}
